import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { HSKLevelProvider } from './context/hskLevelContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HSKLevelProvider>
      <App />
    </HSKLevelProvider>
  </React.StrictMode>
);
